module.exports = __webpack_public_path__ + "static/img/2.cdd0650.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/people/mikse/2.jpg
// module id = zNTY
// module chunks = 0